import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    // NotFound 페이지는 noindex 처리
    let metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.setAttribute('name', 'robots');
      document.head.appendChild(metaRobots);
    }
    metaRobots.setAttribute('content', 'noindex, nofollow');

    document.title = i18n.language === 'uz' ? 'Sahifa topilmadi - MediVoyage' : 'Страница не найдена - MediVoyage';

    return () => {
      metaRobots?.remove();
    };
  }, [i18n.language]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="text-center">
        <div className="w-20 h-20 flex items-center justify-center bg-teal-50 rounded-full mx-auto mb-6">
          <i className="ri-error-warning-line text-4xl text-teal-600"></i>
        </div>
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-8">
          {i18n.language === 'uz' ? 'Sahifa topilmadi' : 'Страница не найдена'}
        </p>
        <button
          onClick={() => navigate('/')}
          className="px-6 py-3 bg-teal-600 text-white font-medium rounded-lg hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          {i18n.language === 'uz' ? 'Bosh sahifaga qaytish' : 'Вернуться на главную'}
        </button>
      </div>
    </div>
  );
}
